import callApiAxiosClient from '../../axios/axios_client';
import { technicalIncidentEventTypeList } from '../../models';

async function getTechnicalIncidentEventTypes(): Promise<technicalIncidentEventTypeList> {
  const token = JSON.parse(localStorage.getItem('user')!);
  const authorization = 'Bearer ' + token.token;

  return callApiAxiosClient<technicalIncidentEventTypeList>({
    method: 'get',
    url: 'technicalincidents/event-types',
    headers: {
      'Content-Type': 'Application/json',
      Authorization: authorization,
    },
  });
}

export default getTechnicalIncidentEventTypes;
